import ErrorInvoicing from './error_invoicing'
import RelatedDistribution from './related_distribution'
import RelatedInvoicing from './related_invoicing'

export default {
  modules: {
    ErrorInvoicing,
    RelatedDistribution,
    RelatedInvoicing
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/invoicing_check/index.js